"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainLinkFundButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const viem_1 = require("viem");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const transferAndCall_json_1 = __importDefault(require("@framework/abis/json/ERC677/transferAndCall.json"));
const dialogs_1 = require("../../../../dialogs");
const validation_1 = require("./dialog/validation");
const ChainLinkFundButton = (props) => {
    const { subscriptionId, className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { address: account } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const metaTransfer = (0, react_hooks_eth_1.useSystemContract)(async (values, systemContract) => {
        // https://docs.chain.link/docs/link-token-contracts/
        const subId = (0, viem_1.pad)((0, viem_1.toHex)(BigInt(values.subscriptionId)), { size: 32 });
        return writeContractAsync({
            address: systemContract.parameters.linkAddress.toString(),
            abi: transferAndCall_json_1.default,
            functionName: "transferAndCall",
            args: [systemContract.address, values.amount, subId],
        });
    });
    const { execute: metaFnTransfer } = (0, react_hooks_eth_1.useMetamask)((values) => {
        return metaTransfer(types_1.SystemModuleType.CHAIN_LINK, values);
    });
    const handleFundConfirm = async ({ data }) => {
        await metaFnTransfer(data);
    };
    const handleFund = () => {
        openDialog(dialogs_1.GlobalDialogKeys.CONTRACT_MINT, {}, {
            initialValues: {
                amount: "0",
                subscriptionId,
            },
            validationSchema: validation_1.chainLinkFundValidationSchema,
            message: "dialogs.fund",
            testId: "FundLinkForm",
            onExternalConfirm: handleFundConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleFund, icon: icons_material_1.Savings, message: "form.buttons.fund", className: className, dataTestId: "ChainLinkFundButton", disabled: disabled || !account, variant: variant }));
};
exports.ChainLinkFundButton = ChainLinkFundButton;
//# sourceMappingURL=index.js.map